export default "__VITE_ASSET__C3CgIKqV__"